import { ESupportType } from "@/types/backoffice/dto/reference/support-type-dto.ts";

const supportLocale = {
  support: {
    title: "Support",
    supportRequest: "Demande de support",
    supportType: "Type de support",
    subscriberNeed: {
      label: "Besoin de l'adhérent",
    },
    success: "Demande de support envoyée avec succès",
    error: "Une erreur s'est produite lors de l'envoi de la demande de support",
    sendSupportRequest: "Envoyer la demande de support",
    type: {
      [ESupportType.TECHNICAL_ASSISTANCE_NOT_URGENT]: "Assistance Technique - non urgent",
      [ESupportType.TECHNICAL_ASSISTANCE_URGENT]: "Assistance Technique - urgent",
      [ESupportType.CLAIM]: "Réclamation",
      [ESupportType.PLANIF_NOT_URGENT]: "Planif - non urgent",
      [ESupportType.PLANIF_URGENT]: "Planif - urgent",
      [ESupportType.IV_TECH_NOT_URGENT]: "IV Tech - non urgent",
      [ESupportType.IV_TECH_URGENT]: "IV Tech - urgent",
      [ESupportType.AIRRIA_NOT_URGENT]: "Airria - non urgent",
      [ESupportType.AIRRIA_URGENT]: "Airria - urgent",
      [ESupportType.CIRCET_NOT_URGENT]: "Circet - non urgent",
      [ESupportType.CIRCET_URGENT]: "Circet - urgent",
      [ESupportType.S30_NOT_URGENT]: "S30 - non urgent",
      [ESupportType.S30_URGENT]: "S30 - urgent",
      [ESupportType.BUGBUSTERS_NOT_URGENT]: "Bugbusters - non urgent",
      [ESupportType.BUGBUSTERS_URGENT]: "Bugbusters - urgent",
      [ESupportType.PAC]: "Pompe à chaleur (PAC)",
      [ESupportType.PSB]: "Programme Saint Bernard (PSB)",
      [ESupportType.CLIMATISATION]: "Climatisation",
      [ESupportType.TERTIAIRE]: "Tertiaire",
    },
  },
};

export type SupportLocale = typeof supportLocale;
export default supportLocale;
